<script lang="ts">
	import ExperienceDetail from '@/components/listing-detail/ExperienceDetail.svelte';
	import RelatedListingsSection from '@/components/listing-detail/RelatedListingsSection.svelte';
	import RentalDetail from '@/components/listing-detail/RentalDetail.svelte';
	import MarketplaceView from '@/components/markets/marketplace-view.svelte';
	import { ListingsKindOptions } from '@/pocketbase/pocketbase-types';

	let { data } = $props();

	const relatedLocationLabel = $derived(
		data.listing?.expand?.boat?.expand?.port?.name ??
			data.listing?.expand?.boat?.expand?.port?.city ??
			null
	);
</script>

{#if data.mode === 'detail' && data.listing}
	{#key data.listing.id}
		{#if data.listing.kind === ListingsKindOptions.experience}
			<ExperienceDetail
				listing={data.listing}
				ownerReviewCount={data.ownerReviewCount ?? 0}
				route={data.route}
				initialReviews={data.listingReviews ?? []}
			/>
		{:else}
			<RentalDetail
				listing={data.listing}
				ownerReviewCount={data.ownerReviewCount ?? 0}
				route={data.route}
				initialReviews={data.listingReviews ?? []}
			/>
		{/if}
		<RelatedListingsSection
			relatedListings={data.relatedListings ?? []}
			locationLabel={relatedLocationLabel}
		/>
	{/key}
{:else}
	<MarketplaceView
		route={data.route}
		cityName={data.cityName}
		portId={data.portId}
		portName={data.portName}
		initialListings={data.initialListings ?? []}
		initialTotalItems={data.initialTotalItems ?? 0}
		initialTotalPages={data.initialTotalPages ?? 0}
		marketplaceSeoKey={data.marketplaceSeoKey}
		featuredReviews={data.featuredReviews ?? []}
	/>
{/if}
